import './commonComponents';
import './vuetify';
import './veeValidate';
import './numeral';
import './qrCodeScanner';

import '@/assets/scss/app.scss';
import '@/assets/css/global.css';
import XssDirective from './xssDirective';
import Vue from 'vue';

Vue.use(XssDirective);
